import axios from 'axios';
import { getMessge } from './messageCreator'
// ----------------------------------------------------------------------
// const baseURL = `https://dev.minibig-api.com/`
const baseURL = `https://prod.minibig-api.com/`

const axiosInstance = axios.create({
  baseURL
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    console.log('error: ', error.response.data)
    if (error.response != null && error.response.data != null) {
      const { code } = error.response.data
      error.response.data.message = getMessge(code)
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);

export default axiosInstance;
